import React, { useState, useEffect } from 'react';
import GlobalNotes from '../../CommonComponents/GlobalNotes';

import { r2_updateData, r2_unfilteredList } from '../../../Helpers/r2_requests';

import { APIROOT } from '../../../Helpers/configs';

import { defineTicketNumber } from '../../../Helpers/helpers';

import { updateData } from '../../../Helpers/requests';

import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { GetAuth } from '../../../Auth/AuthProvider';
import {
  CustomerConstants /* getCabinetType (for later use) */,
} from '../../../Helpers/requests';

import Upload from '../../Upload/Upload';
import ViewUploads from '../../Upload/ViewUploads';
import DragAndDrop from '../../shared/FileUploader';
import FileViewer from '../../shared/FileViewer';

import {
  Box,
  Grid,
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Divider,
  Modal,
} from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

import { ticketTypoTitle, ticketTypoInfo } from '../../shared/commonStyle';
import TechItemHistory from '../TechItemHistory';
// import { fontWeight } from '@mui/system';
// import Ticket from '../Ticket/Ticket';

function createData(id, date, description) {
  return { id, date, description };
}

const uploadModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const TechRepairTicketView = () => {
  const navigateBack = useNavigate();
  const [forceUpdate, setForceUpdate] = useState(1);

  const [openUpload, setOpenUpload] = React.useState(false);
  const handleOpenUpload = () => setOpenUpload(true);
  const handleCloseUpload = () => setOpenUpload(false);

  const [openViewUpload, setOpenViewUpload] = React.useState(false);
  const handleOpenViewUpload = () => setOpenViewUpload(true);
  const handleCloseViewUpload = () => setOpenViewUpload(false);

  const navigateNew = useNavigate();
  const location = useLocation();
  const ticketData = location.state;

  const [categoriesData, setCategoriesData] = useState([]);
  const [regionsData, setRegionsData] = useState([]);

  const [fullTicketData, setFullTicketData] = useState({});

  const enqNotification = GetAuth().Notification;
  const logout = GetAuth().signOut;

  // const setCategory = (event, newValue) => {
  //   // setSelectedCategory(newValue);
  //   setTicketState({ ...ticketState, selectedCategory: newValue });
  //   console.log(ticketState.selectedCategory);
  // };
  // const setStore = (event, newValue) => {
  //   setSelectedStore(newValue);
  // };

  // const handleChange = (event) => {
  //   setTicketState({
  //     ...ticketState,
  //     notify: event.target.checked,
  //   });
  // };

  const cancelEdit = () => {
    return console.log('CancelEdit'); //TO DO
  };

  const clockInBlob = (action) => {
    let blob = {};
    blob = {
      action: {
        do: action,
        id: ticketData.id,
        type: 'repair',
      },
    };
    return blob;
  };

  const handleActions = (event) => {
    const path = '/tech/tech_ticket_view';
    const uri = '/actions';

    const onsiteBlob = 'start';
    const stopBlob = 'stop';
    const pendingBlob = 'submitAuth';

    switch (event.target.id) {
      case 'onSiteButton':
        r2_updateData({
          uri: uri,
          dataBlob: clockInBlob(onsiteBlob),
          cancelEdit: () => {},
          setForceUpdate,
          navigateBack: () => {},
          path: path,
          logout: logout,
          enqNotification: enqNotification,
          updateMessage: 'repair ticket set to "on site"',
          type: 'repair ticket',
          state: 'repair',
        });
        // updateData(
        //   uri,
        //   clockInBlob(onsiteBlob),
        //   cancelEdit,
        //   setForceUpdate,
        //   // navigateBack,
        //   path,
        //   logout,
        //   enqNotification
        // );
        // enqNotification('Onsite', 'success');

        break;
      case 'stopButton':
        r2_updateData({
          uri: uri,
          dataBlob: clockInBlob(stopBlob),
          cancelEdit: () => {},
          setForceUpdate,
          navigateBack: () => {},
          path: path,
          logout: logout,
          enqNotification: enqNotification,
          updateMessage: 'repair ticket set to paused',
          type: 'repair ticket',
          state: 'repair',
        });
        // updateData(
        //   uri,
        //   clockInBlob(stopBlob),
        //   cancelEdit,
        //   setForceUpdate,
        //   // navigateBack,
        //   path,
        //   logout,
        //   enqNotification
        // );
        // enqNotification('Ticket Stoped', 'warning');
        break;
      case 'submitButton':
        r2_updateData({
          uri: uri,
          dataBlob: clockInBlob(pendingBlob),
          cancelEdit: () => {},
          setForceUpdate,
          navigateBack: () => {},
          path: path,
          logout: logout,
          enqNotification: enqNotification,
          updateMessage: 'repair ticket set to pending auth',
          type: 'repair ticket',
          state: 'repair',
        });
        // updateData(
        //   uri,
        //   clockInBlob(pendingBlob),
        //   cancelEdit,
        //   setForceUpdate,
        //   // navigateBack,
        //   path,
        //   logout,
        //   enqNotification
        // );
        // enqNotification('Ticket Submitted', 'information');
        break;

      default:
        enqNotification('Onsite', 'success');
        break;
    }
  };

  const createCabinet = () => {
    // setTicketState({ ...ticketState, cabinetCount: 1 });
    return (
      <Box>
        {ticketData.serial_numbers.map((cabinet, index) => (
          <Box key={index}>
            <Grid
              container
              xs={12}
              md={12}
              flexDirection='row'
              rowGap={1}
              columnGap={0}
              alignContent='flex-start'
              paddingBottom={1}
            >
              <Grid
                container
                xs={12}
                md={12}
                flexDirection='row'
                rowGap={1}
                // columnGap={1}
                // // columnGap={1}
                alignContent='flex-start'
              >
                <Grid item xs={12} lg={1.5}>
                  <Typography style={ticketTypoTitle}>Cabinet Type:</Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={4}
                  style={{
                    background: '#none',
                    border: 'solid 2px #354775',
                    paddingLeft: '5px',
                  }}
                >
                  <Typography style={ticketTypoInfo}>
                    {cabinet.cabType}
                  </Typography>
                </Grid>
                <Grid item xs={0} lg={0.5}></Grid>
                <Grid item xs={12} lg={1.5}>
                  <Typography style={ticketTypoTitle}>
                    Serial Number:
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={4}
                  style={{
                    background: '#none',
                    border: 'solid 2px #354775',
                    paddingLeft: '5px',
                  }}
                >
                  <Typography style={ticketTypoInfo}>
                    {cabinet.serialNo}
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                xs={12}
                md={12}
                flexDirection='row'
                rowGap={1}
                // // columnGap={1}
                alignContent='flex-start'
              >
                <Grid item xs={12} lg={1.5}>
                  <Typography style={ticketTypoTitle}>History:</Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  lg={10}
                  style={{
                    background: '#none',
                    border: 'solid 2px #354775',
                    paddingLeft: '5px',
                  }}
                >
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      background='#none'
                      aria-controls='panel1a-content'
                      id='panel1a-header'
                      style={{ background: '#none' }}
                    >
                      <Typography>Repair History</Typography>
                    </AccordionSummary>
                    <AccordionDetails style={{ background: '#none' }}>
                      <TechItemHistory serialId={cabinet.serialId} />
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        ))}
      </Box>
    );
  };

  // useEffect(() => {
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   setTicketState({
  //     ...ticketState,
  //     selectedCategory: {
  //       id: '77EEFB76-B953-4143-BD8E-FCC9548F0D1F',
  //       name: 'Shoprite',
  //     },
  //   });

  // }, [ticketState]);

  useEffect(() => {
    CustomerConstants({
      resource: `/api/constants/customer`,
      setCategoriesFunc: setCategoriesData,
      setRegionsFunc: setRegionsData,
      setAsset_compFunc: () => {},
      setLoadingFunc: false,
      showNotification: enqNotification,
      logout,
    });
  }, [enqNotification, logout]);

  useEffect(() => {
    r2_unfilteredList({
      resource: `/api/r2_repair_tickets/${location.state.id}`,
      setDataFunc: setFullTicketData,
      showNotification: enqNotification,
      logout,
      payloadBlob: {},
    });
  }, [enqNotification, logout, location.state.id]);

  console.log(fullTicketData);

  useEffect(() => setForceUpdate(forceUpdate + 1), []);

  return (
    <Box
      style={{
        minHeight: '20vh',
        maxWidth: '100vw',
        textAlign: 'left',
        border: 'solid 2px #354775',
        background: '#ebedf8',
        borderRadius: '5px',
      }}
    >
      <Typography
        style={{
          background: '#354775',
          padding: '15px',
          border: 'solid 2px #354775',
          color: '#ffffff',
        }}
        variant='h5'
      >
        TICKET NR:
        {defineTicketNumber('repair', ticketData.id, '5', 'R')}
      </Typography>
      <Box
        name='customerDetails'
        style={{
          minHeight: '20vh',
          // maxWidth: '100%',
          textAlign: 'left',
          background: '#ebedf8',
          borderRadius: '5px',
          padding: '15px',
        }}
      >
        <Grid
          container
          // justifyContent='space-between'
          // alignItems='center'
          flexDirection={{ xs: 'column', sm: 'row' }}
          sx={{ fontSize: '12px' }}
          xs={12}
          md={12}
          lg={12}
          spacing={0}
          rowGap={1}
          // columnGap={1}
        >
          <Grid
            container
            // justifyContent='space-between'
            // alignItems='center'
            flexDirection={{ xs: 'column', sm: 'row' }}
            sx={{ fontSize: '12px' }}
            xs={12}
            md={12}
            lg={12}
          >
            <Grid item xs={12} lg={1.5}>
              <Typography style={ticketTypoTitle}>Category:</Typography>
            </Grid>
            <Grid
              style={{
                background: '#none',
                border: 'solid 2px #354775',
                paddingLeft: '5px',
              }}
              item
              xs={12}
              lg={4}
            >
              <Typography style={ticketTypoInfo}>
                {ticketData.customer_category_name}
              </Typography>
            </Grid>
            <Grid item xs={0} lg={0.5}></Grid>
            <Grid item xs={12} lg={1.5}>
              <Typography style={ticketTypoTitle}>Store Name:</Typography>
            </Grid>
            <Grid
              style={{
                background: '#none',
                border: 'solid 2px #354775',
                paddingLeft: '5px',
              }}
              item
              xs={12}
              lg={4}
            >
              <Typography style={ticketTypoInfo}>
                {ticketData.customer_name}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            flexDirection={{ xs: 'column', sm: 'row' }}
            sx={{ fontSize: '12px' }}
            xs={12}
            md={6}
            lg={6}
            // spacing={0}
            // rowGap={1}
          >
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Address:</Typography>
            </Grid>
            <Grid
              style={{
                background: '#none',
                border: 'solid 2px #354775',
                paddingLeft: '5px',
              }}
              item
              xs={12}
              lg={8}
            >
              <Typography style={ticketTypoInfo}>
                {ticketData.customer_address}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            flexDirection={{ xs: 'column', sm: 'row' }}
            sx={{ fontSize: '12px' }}
            xs={12}
            md={6}
            lg={6}
            // spacing={0}
            rowGap={1}
          >
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Branch Code:</Typography>
            </Grid>
            <Grid
              style={{
                background: '#none',
                border: 'solid 2px #354775',
                paddingLeft: '5px',
              }}
              item
              xs={12}
              lg={8}
            >
              <Typography style={ticketTypoInfo}>
                {ticketData.customer_branchcode}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>WI Nr:</Typography>
            </Grid>
            <Grid
              style={{
                background: '#none',
                border: 'solid 2px #354775',
                paddingLeft: '5px',
              }}
              item
              xs={12}
              lg={8}
            >
              <Typography style={ticketTypoInfo}>
                {ticketData.wi_number}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Asset Comp:</Typography>
            </Grid>
            <Grid
              style={{
                background: '#none',
                border: 'solid 2px #354775',
                paddingLeft: '5px',
              }}
              item
              xs={12}
              lg={8}
            >
              <Typography style={ticketTypoInfo}>
                {ticketData.customer_asset_comp_name}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={1.5}>
            <Typography style={ticketTypoTitle}>Contact Person:</Typography>
          </Grid>
          <Grid
            style={{
              background: '#none',
              border: 'solid 2px #354775',
              paddingLeft: '5px',
            }}
            item
            xs={12}
            lg={4}
          >
            <Typography style={ticketTypoInfo}>
              {ticketData.customer_contact_name}
            </Typography>
          </Grid>

          <Grid item xs={0} lg={0.5}></Grid>
          <Grid item xs={12} lg={1.5}>
            <Typography style={ticketTypoTitle}>Contact Number:</Typography>
          </Grid>
          <Grid
            style={{
              background: '#none',
              border: 'solid 2px #354775',
              paddingLeft: '5px',
            }}
            item
            xs={12}
            lg={4}
          >
            <Typography style={ticketTypoInfo}>
              {ticketData.customer_contact_number}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Divider />
      <Box
        style={{
          minHeight: '60px',
          // maxWidth: '100%',
          textAlign: 'left',
          background: '#ebedf8',
          borderRadius: '5px',
          padding: '15px',
        }}
      >
        <Grid
          container
          flexDirection={{ xs: 'column', sm: 'row' }}
          sx={{ fontSize: '12px' }}
          xs={12}
          md={12}
          // spacing={0}
          // rowGap={1}
        >
          <Grid item xs={12} lg={1.5}>
            <Typography style={ticketTypoTitle}>
              Problem/Issue Reported:
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            lg={10}
            style={{
              background: '#none',
              border: 'solid 2px #354775',
              paddingLeft: '5px',
            }}
          >
            <Typography style={ticketTypoInfo}>
              {ticketData.description}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box
        style={{
          // minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'left',
          borderRadius: '5px',
          padding: '0 15px 15px 15px',
        }}
      >
        <Typography variant='h6'>Logged Cabinets:</Typography>
        {createCabinet()}
      </Box>
      <Divider style={{ marginBottom: '15px' }} />

      <Box
        name='ticketDetails'
        style={{
          // minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'left',
          borderRadius: '5px',
          padding: '0 15px 15px 15px',
        }}
      >
        <Grid
          container
          // justifyContent='space-between'
          // alignItems='center'
          flexDirection={{ xs: 'column', sm: 'row' }}
          sx={{ fontSize: '12px' }}
          xs={12}
          md={12}
          lg={12}
          spacing={0}
          rowGap={1}
          // columnGap={1}
        >
          <Grid
            container
            // justifyContent='space-between'
            // alignItems='center'
            flexDirection={{ xs: 'column', sm: 'row' }}
            sx={{ fontSize: '12px' }}
            xs={12}
            md={12}
            lg={12}
          >
            <Grid item xs={12} lg={1.5}>
              <Typography style={ticketTypoTitle}>
                Communication Notes:
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              lg={10}
              style={{
                background: '#none',
                border: 'solid 2px #354775',
                // paddingLeft: '5px',
              }}
            >
              <GlobalNotes
                relationId={ticketData.id}
                relationType='ticketTable'
              />

              {/* <Typography style={ticketTypoInfo}>{ticketData.notes}</Typography> */}
            </Grid>
          </Grid>
        </Grid>
      </Box>

      <Divider />
      <Box
        name='ticketActions'
        style={{
          // minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'right',
          borderRadius: '5px',
          padding: '0 15px 15px 15px',
          margin: '10 0',
        }}
      >
        <Button
          variant='contained'
          color='warning'
          style={{ margin: '15px 5px', fontWeight: '700' }}
          onClick={handleOpenViewUpload}
        >
          View Docs
        </Button>
        <Button
          id='onSiteButton'
          variant='contained'
          color='primary'
          style={{ margin: '15px 5px', fontWeight: '700' }}
          onClick={(event) => handleActions(event)}
        >
          Onsite
        </Button>
        <Button
          id='stopButton'
          variant='contained'
          color='error'
          style={{ margin: '15px 5px', fontWeight: '700' }}
          onClick={(event) => handleActions(event)}
        >
          Pause
        </Button>
        {console.log(fullTicketData)}
        <Button
          variant='contained'
          color='success'
          style={{ margin: '15px 5px', fontWeight: '700' }}
          onClick={() => {
            navigateNew(`/tech/tech_ticket_view/jobcard`, {
              replace: true,
              state: fullTicketData.repair_ticket,
            });
          }}
        >
          Open JC
        </Button>
        <Button
          variant='contained'
          color='success'
          sx={{ margin: '15px 5px', fontWeight: '700' }}
          onClick={() => {
            navigateNew(`/tech/tech_ticket_view/checkSheet`, {
              replace: true,
              state: fullTicketData,
            });
          }}
        >
          Open Check Sheet
        </Button>
        <Button
          onClick={handleOpenUpload}
          variant='contained'
          color='success'
          style={{ margin: '15px 5px', fontWeight: '700' }}
        >
          Upload
        </Button>
        <Button
          id='submitButton'
          variant='contained'
          color='success'
          style={{ margin: '15px 5px', fontWeight: '700' }}
          onClick={(event) => handleActions(event)}
        >
          Submit
        </Button>
        <Button
          id='BackButton'
          variant='contained'
          color='success'
          style={{ margin: '15px 5px', fontWeight: '700' }}
          onClick={() => navigateBack('/tech/tickets')}
        >
          Back
        </Button>
        <Grid
          container
          xs={12}
          md={12}
          flexDirection='row'
          rowGap={1}
          columnGap={1}
          alignContent='flex-start'
        ></Grid>
      </Box>
      {/* FILE UPLOAD MODAL */}
      <Modal
        open={openUpload}
        onClose={handleCloseUpload}
        aria-labelledby='modal-fileUpload'
        aria-describedby='modal-file-uloader'
      >
        <Box sx={uploadModalStyle}>
          <Upload relationId={ticketData.id} relationType='repairTickets' />
        </Box>
      </Modal>
      {/* FILE VIEW MODAL */}
      <Modal
        open={openViewUpload}
        onClose={handleCloseViewUpload}
        aria-labelledby='modal-file -View-Upload'
        aria-describedby='modal-file-view-uploader'
      >
        <Box sx={uploadModalStyle}>
          <ViewUploads
            relationId={ticketData.id}
            relationType='repairTickets'
          />
        </Box>
      </Modal>
    </Box>
  );
};

export default TechRepairTicketView;

function fetchHistory(serialID, setDataFunc) {
  //Get JWT from storage
  let JWT = localStorage.getItem('JWT_Key');

  //Set default Headers
  let headers = {
    'content-type': 'application/JSON',
  };
  //Set JWT in header if available
  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  const request = new Request(
    `${APIROOT}/api/serialnumberhistory/${serialID}`,
    { method: 'POST', headers: headers }
  );

  fetch(request)
    .then((data) => {
      if (data.status === 200) {
        return data.text();
      } else {
        throw new Error(`Invalid Response`);
      }
    })
    .then((data) => {
      var parsed = JSON.parse(data);
      if (parsed.success === true) {
        setDataFunc(parsed.data.value);
        if (parsed.JWT) {
          localStorage.setItem('JWT_Key', parsed.JWT);
        }
      }
    })
    .catch((error) => {
      console.log(error);
    });
}
